<template>
    <div class="sub_contents">
        <div class="cont_center">
            <h2 class="title_page">MY PAGE</h2>
            <div class="mypage_area">
                <ul class="sub_link_list">
                    <li class="on">
                        <RouterLink to="/HFO_MP_003">1:1 문의 내역</RouterLink>
                    </li>
                    <li>
                        <RouterLink to="/HFO_MP_005">개인정보관리</RouterLink>
                    </li>
                </ul>

                <div class="tab_contents" v-if="currentTab === 0">
                    <!-- 리스트 -->
                    <TableList>
                        <template #col>
                            <col style="width: 15.7%;" />
                            <col />
                            <col style="width: 15.6%;" />
                            <col style="width: 12.65%;" />
                        </template>
                        <template #header>
                            <th>분류</th>
                            <th>제 목</th>
                            <th>일시</th>
                            <th>상태</th>
                        </template>
                        <template #list>
                            <tr :key="item.uuid" v-for="item in eventList" class="content-row">
                                <td class="category-cell">
                                    <span class="category">{{ item.qnaTypeName }}</span>
                                    <!-- 모바일용 날짜/상태 정보 (category와 같은 라인) -->
                                    <div class="mobile-date-status">
                                        <span class="mobile-date">{{ item.regDt }}</span>
                                        <span class="mobile-status">{{ item.sttsTypeName }}</span>
                                    </div>
                                </td>
                                <td class="t_left title">
                                    <a href="#"
                                        @click="routerLink(item.sttsType, item.qnaTitle, item.qnaRmks, item.replyRmks, item.regDt, item.replyDt)">{{
                                            item.qnaTitle }}</a>
                                </td>
                                <td class="desktop-date">{{ item.regDt }}</td>
                                <td class="desktop-status">{{ item.sttsTypeName }}</td>
                            </tr>
                        </template>
                    </TableList>
                    <!-- //리스트 -->
                    <!-- 페이징 -->
                    <PagingCom :currentPage="currentPage" :pageSize="pageSize" :totalItems="total"
                        @pageChange="onPageChange" />
                </div>

                <div class="tab_contents" v-if="currentTab === 1">
                    <!-- 리스트 -->
                    <TableList>
                        <template #col>
                            <col style="width: 15.7%;" />
                            <col />
                            <col style="width: 15.6%;" />
                            <col style="width: 12.65%;" />
                        </template>
                        <template #header>
                            <th>분류</th>
                            <th>제 목</th>
                            <th>일시</th>
                            <th>상태</th>
                        </template>
                        <template #list>
                            <tr :key="item.uuid" v-for="item in eventList" class="content-row">
                                <td class="category-cell">
                                    <span class="category">{{ item.qnaTypeName }}</span>
                                    <div class="mobile-date-status">
                                        <span class="mobile-date">{{ item.regDt }}</span>
                                        <span class="mobile-status">{{ item.sttsTypeName }}</span>
                                    </div>
                                </td>
                                <td class="t_left title">
                                    <a href="#"
                                        @click="routerLink(item.sttsType, item.qnaTitle, item.qnaRmks, item.replyRmks, item.regDt, item.replyDt)">{{
                                            item.qnaTitle }}</a>
                                </td>
                                <td class="desktop-date">{{ item.regDt }}</td>
                                <td class="desktop-status">{{ item.sttsTypeName }}</td>
                            </tr>
                        </template>
                    </TableList>
                    <!-- //리스트 -->
                    <!-- 페이징 -->
                    <PagingCom :currentPage="currentPage" :pageSize="pageSize" :totalItems="total"
                        @pageChange="onPageChange" />
                </div>

                <div class="tab_contents" v-if="currentTab === 2">
                    <!-- 리스트 -->
                    <TableList>
                        <template #col>
                            <col style="width: 15.7%;" />
                            <col />
                            <col style="width: 15.6%;" />
                            <col style="width: 12.65%;" />
                        </template>
                        <template #header>
                            <th>분류</th>
                            <th>제 목</th>
                            <th>일시</th>
                            <th>상태</th>
                        </template>
                        <template #list>
                            <tr :key="item.uuid" v-for="item in eventList" class="content-row">
                                <td class="category-cell">
                                    <span class="category">로그인/회원가입</span>
                                    <div class="mobile-date-status">
                                        <span class="mobile-date">{{ item.regDt }}</span>
                                        <span class="mobile-status">{{ item.sttsTypeName }}</span>
                                    </div>
                                </td>
                                <td class="t_left title">
                                    <a href="#"
                                        @click="routerLink(item.sttsType, item.qnaTitle, item.qnaRmks, item.replyRmks, item.regDt, item.replyDt)">{{
                                            item.qnaTitle }}</a>
                                </td>
                                <td class="desktop-date">{{ item.regDt }}</td>
                                <td class="desktop-status">{{ item.sttsTypeName }}</td>
                            </tr>
                        </template>
                    </TableList>
                    <!-- //리스트 -->
                    <!-- 페이징 -->
                    <PagingCom :currentPage="currentPage" :pageSize="pageSize" :totalItems="total"
                        @pageChange="onPageChange" />
                </div>

                <div class="tab_contents" v-if="currentTab === 3">
                    <!-- 리스트 -->
                    <TableList>
                        <template #col>
                            <col style="width: 15.7%;" />
                            <col />
                            <col style="width: 15.6%;" />
                            <col style="width: 12.65%;" />
                        </template>
                        <template #header>
                            <th>분류</th>
                            <th>제 목</th>
                            <th>일시</th>
                            <th>상태</th>
                        </template>
                        <template #list>
                            <tr :key="item.uuid" v-for="item in eventList" class="content-row">
                                <td class="category-cell">
                                    <span class="category">로그인/회원가입</span>
                                    <div class="mobile-date-status">
                                        <span class="mobile-date">{{ item.regDt }}</span>
                                        <span class="mobile-status">{{ item.sttsTypeName }}</span>
                                    </div>
                                </td>
                                <td class="t_left title">
                                    <a href="#"
                                        @click="routerLink(item.sttsType, item.qnaTitle, item.qnaRmks, item.replyRmks, item.regDt, item.replyDt)">{{
                                            item.qnaTitle }}</a>
                                </td>
                                <td class="desktop-date">{{ item.regDt }}</td>
                                <td class="desktop-status">{{ item.sttsTypeName }}</td>
                            </tr>
                        </template>
                    </TableList>
                    <!-- //리스트 -->
                    <!-- 페이징 -->
                    <PagingCom :currentPage="currentPage" :pageSize="pageSize" :totalItems="total"
                        @pageChange="onPageChange" />
                </div>

                <div class="tab_contents" v-if="currentTab === 4">
                    <!-- 리스트 -->
                    <TableList>
                        <template #col>
                            <col style="width: 15.7%;" />
                            <col />
                            <col style="width: 15.6%;" />
                            <col style="width: 12.65%;" />
                        </template>
                        <template #header>
                            <th>분류</th>
                            <th>제 목</th>
                            <th>일시</th>
                            <th>상태</th>
                        </template>
                        <template #list>
                            <tr :key="item.uuid" v-for="item in eventList" class="content-row">
                                <td class="category-cell">
                                    <span class="category">로그인/회원가입</span>
                                    <div class="mobile-date-status">
                                        <span class="mobile-date">{{ item.regDt }}</span>
                                        <span class="mobile-status">{{ item.sttsTypeName }}</span>
                                    </div>
                                </td>
                                <td class="t_left title">
                                    <a href="#"
                                        @click="routerLink(item.sttsType, item.qnaTitle, item.qnaRmks, item.replyRmks, item.regDt, item.replyDt)">{{
                                            item.qnaTitle }}</a>
                                </td>
                                <td class="desktop-date">{{ item.regDt }}</td>
                                <td class="desktop-status">{{ item.sttsTypeName }}</td>
                            </tr>
                        </template>
                    </TableList>
                    <!-- //리스트 -->
                    <!-- 페이징 -->
                    <PagingCom :currentPage="currentPage" :pageSize="pageSize" :totalItems="total"
                        @pageChange="onPageChange" />
                </div>

                <div class="tab_contents" v-if="currentTab === 5">
                    <!-- 리스트 -->
                    <TableList>
                        <template #col>
                            <col style="width: 15.7%;" />
                            <col />
                            <col style="width: 15.6%;" />
                            <col style="width: 12.65%;" />
                        </template>
                        <template #header>
                            <th>분류</th>
                            <th>제 목</th>
                            <th>일시</th>
                            <th>상태</th>
                        </template>
                        <template #list>
                            <tr :key="item.uuid" v-for="item in eventList" class="content-row">
                                <td class="category-cell">
                                    <span class="category">로그인/회원가입</span>
                                    <div class="mobile-date-status">
                                        <span class="mobile-date">{{ item.regDt }}</span>
                                        <span class="mobile-status">{{ item.sttsTypeName }}</span>
                                    </div>
                                </td>
                                <td class="t_left title">
                                    <a href="#"
                                        @click="routerLink(item.sttsType, item.qnaTitle, item.qnaRmks, item.replyRmks, item.regDt, item.replyDt)">{{
                                            item.qnaTitle }}</a>
                                </td>
                                <td class="desktop-date">{{ item.regDt }}</td>
                                <td class="desktop-status">{{ item.sttsTypeName }}</td>
                            </tr>
                        </template>
                    </TableList>
                    <!-- //리스트 -->
                    <!-- 페이징 -->
                    <PagingCom :currentPage="currentPage" :pageSize="pageSize" :totalItems="total"
                        @pageChange="onPageChange" />
                </div>
            </div>

            <!-- //페이징 -->
        </div>
    </div>
    <AlertPopup v-model="alertRequiredShow" title="알림">
        <template #layer_content>
            <p class="alert_txt" id="alert_txt">
                {{ alertContent }}
            </p>
        </template>
    </AlertPopup>
</template>

<script>
import TabArea from '@/components/TabArea'
import TableList from '@/components/TableList'
import PagingCom from '@/components/PagingCom'
import AlertPopup from '@/components/AlertPopup.vue';
import { ref, watch } from 'vue';
import { useQuery } from '@tanstack/vue-query';
import { getAxios } from '@/lib/AxiosCall';
import { useRouter } from 'vue-router';
import { getAccessToken, getUserId, getUserUuid } from "@/lib/UserInfo";

export default {
    components: {
        //TabArea,
        TableList,
        PagingCom,
        AlertPopup
    },
    data() {
        return {
            currentTab: 0,
            qnaType: 'QNA_MEMBER',
            tab: [
                {
                    name: '전체',
                    type: ''
                },
                {
                    name: '로그인/회원가입',
                    type: 'QNA_MEMBER'
                },
                {
                    name: '가맹점 정보',
                    type: 'QNA_STORE'
                },
                {
                    name: '결제/카드',
                    type: 'QNA_PAYMENT'
                },
                {
                    name: '사이트 이용',
                    type: 'QNA_SITE'
                },
                {
                    name: '기타',
                    type: 'QNA_ETC'
                }
            ],
            alertRequiredShow: false,
        }
    },
    setup() {
        const router = useRouter();
        const currentPage = ref(1);
        const pageSize = ref(10);
        const total = ref(0);
        let eventList = ref([]);
        const eventReqData = ref({
            qnaType: '',
            page: currentPage.value,
            size: pageSize.value,
            userId: getUserId()
        });

        const eventData = useQuery({
            queryKey: ['get-branch-event', new Date().getTime(), eventReqData.value],
            queryFn: () => getAxios("/hvm/v1/help/qna", eventReqData.value),
            enabled: true,
        });
        eventData.refetch();

        watch(() => eventData.data.value, (newData) => {
            if (newData && newData.page && newData.page.list) {
                eventList.value = [...eventList.value, ...newData.page.list];
                total.value = newData.page.total;
            }

        });


        return {
            eventList,
            eventData,
            eventReqData,
            currentPage,
            pageSize,
            total,
            router
        };

    },
    methods: {
        changeTab(key) {
            console.log(this.tab[key].type)
            this.eventReqData.qnaType = this.tab[key].type;
            console.log(this.eventReqData.qnaType)
            this.currentTab = key;

            this.eventList = [];
            this.currentPage = 1;
            this.eventReqData.page = 1;
            this.eventData.refetch();
        },
        onPageChange(newPage) {
            this.eventList = [];
            this.currentPage = newPage;
            this.eventReqData.page = newPage;
            this.eventData.refetch();
        },
        routerLink(sttsType, qnaTitle, qnaRmks, replyRmks, regDt, replyDt) {
            if (sttsType != 'QNA_REGISTER') {
                sessionStorage.setItem('qnaTitle', qnaTitle);
                sessionStorage.setItem('qnaRmks', qnaRmks);
                sessionStorage.setItem('replyRmks', replyRmks);
                sessionStorage.setItem('regDt', regDt);
                sessionStorage.setItem('replyDt', replyDt); // replyDt 추가
                this.router.push("/HFO_MP_004");
            } else {
                this.alertContent = '답변 대기중인 문의 입니다'
                this.alertRequiredShow = true;
            }
        }
    }
}
</script>
<style scoped>
/* MY PAGE 제목과 mypage_area 사이 마진 조정 */
.mypage_area {
    margin-top: 5px !important;
    /* 기존 60px → 20px */
    padding-top: 5px !important;
    /* 기존 32px → 15px */
}

/* PC와 모바일 구분 조정 */
@media (min-width: 1024px) {
    .mypage_area {
        margin-top: 5px !important;
        /* PC에서 25px */
        padding-top: 5px !important;
        /* PC에서 20px */
    }

    /* PC에서 모바일 전용 요소 숨김 */
    .mobile-date-status {
        display: none !important;
    }

    .desktop-date,
    .desktop-status {
        display: table-cell !important;
    }

    .category-cell {
        text-align: center;
    }
}

@media (max-width: 1023px) {
    .mypage_area {
        margin-top: 5px !important;
        /* 모바일에서 15px */
        padding-top: 5px !important;
        /* 모바일에서 10px */
    }

    /* 카테고리 셀 레이아웃 */
    .category-cell {
        display: flex !important;
        justify-content: space-between !important;
        align-items: center !important;
        padding: 8px 10px !important;
    }

    .category {
        font-size: 12px;
        padding: 2px 6px;
        background-color: #e9ecef;
        border-radius: 8px;
        flex-shrink: 0;
        /* 크기 고정 */
    }

    /* 모바일용 날짜/상태 스타일 */
    .mobile-date-status {
        display: flex !important;
        gap: 8px;
        align-items: center;
        font-size: 12px;
    }

    .mobile-date {
        color: #666;
        font-weight: 500;
        white-space: nowrap;
    }

    .mobile-status {
        color: #007bff;
        font-weight: 600;
        padding: 2px 6px;
        background-color: #e3f2fd;
        border-radius: 8px;
        font-size: 12px;
        white-space: nowrap;
    }

    /* PC용 날짜/상태 컬럼 숨김 */
    .desktop-date,
    .desktop-status {
        display: none !important;
    }

    /* 제목 행 스타일 조정 */
    .content-row .title a {
        font-size: 14px;
        line-height: 1.4;
        display: block;
        padding: 8px 10px;
    }
}

/* 테이블 행 구분을 위한 추가 스타일 */
@media (max-width: 1023px) {
    .inquiry-row+.content-row {
        border-top: 1px solid #e9ecef;
    }

    .content-row+.inquiry-row {
        border-top: 2px solid #dee2e6;
        margin-top: 8px;
    }
}
</style>